import React from 'react';
import { Result, Spin, Typography } from 'antd';
import { useTheme } from '../../hooks/useTheme';

const { Text } = Typography;

/**
 * Página de carregamento.
 * 
 * Exibida enquanto a aplicação está carregando dados iniciais.
 * Adaptada para suportar dark mode.
 */
const Loading: React.FC = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: isDark ? '#141414' : '#ffffff',
        transition: 'background-color 0.3s ease',
      }}
    >
      <Result
        icon={<Spin size="large" />}
        title={
          <Text 
            type={isDark ? undefined : 'secondary'}
            style={{ 
              color: isDark ? '#ffffff' : undefined,
            }}
          >
            Carregando...
          </Text>
        }
      />
    </div>
  );
};

export default Loading;
